import { createActions } from 'reduxsauce';

const { Types, Creators } = createActions({
    getcareerprogramRequest: ['programId', 'route', 'userId'],
    getcareerprogramSuccess: ['response'],
    getcareerprogramFailure: null,

    postcareerprogramRequest: ['payload'],
    postcareerprogramSuccess: ['response'],
    postcareerprogramFailure: null,

    gettasksfeedRequest: ['userId', 'payload'],
    gettasksfeedSuccess: ['response'],
    gettasksfeedFailure: null,

    companyprojectsRequest: ['companyIds', 'userIds'],
    companyprojectsSuccess: ['response'],
    companyprojectsFailure: null,

    selectprojectRequest: ['project', 'userIds'],
    selectprojectSuccess: ['response'],
    selectprojectFailure: null,

    userprojecttaskRequest: ['payload'],
    userprojecttaskSuccess: ['response'],
    userprojecttaskFailure: null,

    addtaskRequest: ['payload', 'users', 'projectId'],
    addtaskSuccess: ['response'],
    addtaskFailure: null,

    updatetaskRequest: ['event', 'cardId', 'after'],
    updatetaskSuccess: ['response'],
    updatetaskFailure: null,

    edittaskRequest: ['payload'],
    edittaskSuccess: ['response'],
    edittaskFailure: null,

    deletetaskRequest: ['cardInstanceId', 'mode', 'after'],
    deletetaskSuccess: ['response'],
    deletetaskFailure: null,

    fetchtaskdetailRequest: ['cardInstanceId', 'mode'],
    fetchtaskdetailSuccess: ['response'],
    fetchtaskdetailFailure: null,

    addmngcommentRequest: ['payload', 'cardInstanceId'],
    addmngcommentSuccess: ['response'],
    addmngcommentFailure: null,

    fetchprojectsdetailRequest: null,
    fetchprojectsdetailSuccess: ['response'],
    fetchprojectsdetailFailure: null,
    fetchprojectdetailComplete: null, // This action is needed, because multiple fetch to different url is done to get all project wise tasks

    searchmodulesRequest: ['payload'],
    searchmodulesSuccess: ['response'],
    searchmodulesFailure: null,

    addprojectRequest: ['payload', 'companyId'],
    addprojectSuccess: ['response'],
    addprojectFailure: null,

    updateprojectRequest: ['payload', 'companyId', 'projectId'],
    updateprojectSuccess: ['response'],
    updateprojectFailure: null,

    deleteprojectRequest: ['projectId', 'companyId'],
    deleteprojectSuccess: ['response'],
    deleteprojectFailure: null,

    assigntrainingRequest: ['payload', 'after', 'attendance', 'callback'],
    assigntrainingSuccess: ['target', 'response'],
    assigntrainingFailure: null,

    assigncoursesRequest: ['payload'],
    assigncoursesSuccess: ['response'],
    assigncoursesFailure: null,

    unassigncontentRequest: ['payload'],
    unassigncontentSuccess: ['response'],
    unassigncontentFailure: null,

    companyindividualRequest: ['payload', 'loading'],
    companyindividualSuccess: ['response'],
    companyindividualFailure: null,

    fetchengagementreportRequest: ['payload', 'by', 'mode'],
    fetchengagementreportSuccess: ['response'],
    fetchengagementreportFailure: null,

    fetchcompanycareersRequest: ['companyId'],
    fetchcompanycareersSuccess: ['response'],
    fetchcompanycareersFailure: null,

    fetchcertificationsreportRequest: ['target', 'payload'],
    fetchcertificationsreportSuccess: ['response'],
    fetchcertificationsreportFailure: null,

    fetchcareerreportsRequest: ['target', 'userIds', 'payload'],
    fetchcareerreportsSuccess: ['response'],
    fetchcareerreportsFailure: null,

    fetchhireorientationreportRequest: ['payload'],
    fetchhireorientationreportSuccess: ['response'],
    fetchhireorientationreportFailure: null,

    companyperformancereviewsRequest: ['payload', 'loading'],
    companyperformancereviewsSuccess: ['response'],
    companyperformancereviewsFailure: null,

    companyperformancereviewsstatsRequest: ['payload', 'loading'],
    companyperformancereviewsstatsSuccess: ['response'],
    companyperformancereviewsstatsFailure: null,

    companydailycheckoutsRequest: ['payload', 'loading'],
    companydailycheckoutsSuccess: ['response'],
    companydailycheckoutsFailure: null,

    getcompanycheckoutsRequest: ['payload', 'route', 'loading'],
    getcompanycheckoutsSuccess: ['response'],
    getcompanycheckoutsFailure: null,

    individualperformancereviewRequest: ['payload', 'route'],
    individualperformancereviewSuccess: ['response'],
    individualperformancereviewFailure: null,

    postperformancereviewRequest: ['payload'],
    postperformancereviewSuccess: ['response'],
    postperformancereviewFailure: null,

    postperformancereviewresetRequest: ['payload', 'after'],
    postperformancereviewresetSuccess: ['response'],
    postperformancereviewresetFailure: null,

    getperformancereviewsRequest: ['id', 'payload', 'route'],
    getperformancereviewsSuccess: ['response'],
    getperformancereviewsFailure: null,

    getpreviousreviewtasksRequest: ['id', 'userId', 'payload', 'loading'],
    getpreviousreviewtasksSuccess: ['response'],
    getpreviousreviewtasksFailure: null,

    getmanagerdashboardRequest: ['companyId', 'dateStart', 'dateEnd'],
    getmanagerdashboardSuccess: ['response'],
    getmanagerdashboardFailure: null,

    postquotaactualsRequest: ['id', 'payload', 'after', 'callback'],
    postquotaactualsSuccess: ['id', 'response'],
    postquotaactualsFailure: null,

    getanniversarybirthdayRequest: ['companyId', 'base', 'payload'],
    getanniversarybirthdaySuccess: ['response'],
    getanniversarybirthdayFailure: null,

    posttrainingreportsRequest: ['payload', 'target'],
    posttrainingreportsSuccess: ['response', 'target'],
    posttrainingreportsFailure: null,

    postquotaactualcommentRequest: ['payload'],
    postquotaactualcommentSuccess: ['response'],
    postquotaactualcommentFailure: null,

    postupdateactualcommentsRequest: ['payload', 'after'],
    postupdateactualcommentsSuccess: ['response'],
    postupdateactualcommentsFailure: null,

    postsignoffRequest: ['payload', 'completed', 'after'],
    postsignoffSuccess: ['response'],
    postsignoffFailure: null,

    postquotareportRequest: ['payload'],
    postquotareportSuccess: ['response'],
    postquotareportFailure: null,

    posttrainingcompetencyreportRequest: ['payload'],
    posttrainingcompetencyreportSuccess: ['response'],
    posttrainingcompetencyreportFailure: null,

    postterminateemployeeRequest: ['companyId', 'payload'],
    postterminateemployeeSuccess: ['response'],
    postterminateemployeeFailure: null,

    postindividualquotareportRequest: ['payload', 'route'],
    postindividualquotareportSuccess: ['response'],
    postindividualquotareportFailure: null,

    getquotasactualsRequest: ['userId', 'payload'],
    getquotasactualsSuccess: ['response'],
    getquotasactualsFailure: null,

    getcompanyorgchartRequest: ['companyId'],
    getcompanyorgchartSuccess: ['response'],
    getcompanyorgchartFailure: null,

    getsaveactualsreportRequest: ['payload', 'loading'],
    getsaveactualsreportSuccess: ['response'],
    getsaveactualsreportFailure: null,

    getcheckoutactualsRequest: ['payload'],
    getcheckoutactualsSuccess: ['response'],
    getcheckoutactualsFailure: null,

    getcheckoutorgchartRequest: ['payload', 'loading'],
    getcheckoutorgchartSuccess: ['response'],
    getcheckoutorgchartFailure: null,

    posttrainingtrackreportRequest: ['payload'],
    posttrainingtrackreportSuccess: ['response'],
    posttrainingtrackreportFailure: null,

    trainingtrackdetailreportRequest: ['payload', 'route'],
    trainingtrackdetailreportSuccess: ['response'],
    trainingtrackdetailreportFailure: null,

    postteamactivityreportRequest: ['payload'],
    postteamactivityreportSuccess: ['response'],
    postteamactivityreportFailure: null,

    postdeletescorecardRequest: ['payload', 'after'],
    postdeletescorecardSuccess: ['response'],
    postdeletescorecardFailure: null,

    getdailyfeedRequest: ['userId'],
    getdailyfeedSuccess: ['response'],
    getdailyfeedFailure: null,

    getcheckoutRequest: ['payload', 'route'],
    getcheckoutSuccess: ['response'],
    getcheckoutFailure: null,

    postaddcheckoutcommentRequest: ['payload'],
    postaddcheckoutcommentSuccess: ['response'],
    postaddcheckoutcommentFailure: null,

    postcheckouteditRequest: ['payload'],
    postcheckouteditSuccess: null,
    postcheckouteditFailure: null,

    postcheckoutsignoffRequest: ['payload'],
    postcheckoutsignoffSuccess: ['response'],
    postcheckoutsignoffFailure: null,

    postcheckoutskipdayRequest: ['payload', 'after', 'callback'],
    postcheckoutskipdaySuccess: ['response'],
    postcheckoutskipdayFailure: null,

    postcheckoutresetRequest: ['payload', 'after'],
    postcheckoutresetSuccess: ['response'],
    postcheckoutresetFailure: null,

    postcheckoutapproveRequest: ['payload'],
    postcheckoutapproveSuccess: ['response'],
    postcheckoutapproveFailure: null,

    selectusersRequest: ['payload'],
    selectedprojectRequest: ['projectId'],

    resetRequest: null,

    // Clear all caches
    clearRequest: null,
});

export const ManageTypes = Types;
export default Creators;
